'use client'

export function useMenu() {
  return {
    menuData: null,
    loading: false,
    error: null
  }
}
